import ThresholdRange
  from '@avtechsoftware/ra-javascript-utilities/src/classes/thresholdranges/ThresholdRange';
import { findReadingTypeById } from '@avtechsoftware/ra-javascript-utilities/src/types/ReadingType';

class RaaThresholdRange extends ThresholdRange {
  constructor(
    id,
    typeId,
    groupId,
    operatorId,
    subscriptionId,
    name,
    value,
    altValue,
    hysteresis,
    channelTypeId,
    customUnits,
    defaultColor,
    readingType,
    alertCount = 0,
    metricsGroupCount = 0,
  ) {
    super(
      id,
      typeId,
      groupId,
      operatorId,
      subscriptionId,
      name,
      value,
      altValue,
      hysteresis,
      channelTypeId,
      customUnits,
      defaultColor,
    );
    this.readingType = readingType;
    this.alertCount = alertCount;
    this.metricsGroupCount = metricsGroupCount;
  }

  get numUsedDisplay() {
    const alertPart = this.alertCount > 0
      ? `${this.alertCount} ${this.alertCount === 1 ? 'alert' : 'alerts'}`
      : '';

    const graphPart = this.metricsGroupCount > 0
      ? `${this.metricsGroupCount} ${this.metricsGroupCount === 1 ? 'graph' : 'graphs'}`
      : '';

    if (alertPart && graphPart) {
      return `${alertPart} & ${graphPart}`;
    }

    return alertPart || graphPart || 'None';
  }

  getDisplayValueWithUnits(value, temperatureScale) {
    const readingType = findReadingTypeById(this.readingType);
    return `${readingType.toUserDisplayValue(value)} ${readingType.getUnits({ temperatureScale })}`;
  }
}

export default RaaThresholdRange;
